/* eslint-disable array-callback-return */
import team from "../../../assets/team-card.png";
import twitter from "../../../assets/team-twitter.png";
import linkedin from "../../../assets/team-linkedin.png";
import teams from "./teams.json";
console.log(teams);

const Team = () => {
  return (
    <div className="lg:px-16 px-6 my-10">
      <div>
        <h1 className="font-semibold text-primaryBlack text-[32px] lg:text-[40px] lg:max-w-[400px] lg:leading-[54px] mb-7">
          Meet our top team of professionals
        </h1>
        <div className="lg:grid grid-cols-3 gap-20 max-lg:space-y-9">
          {teams.map((teamMember) => {
            return (
              <div className="">
                <img src={team} alt="" />
                <div className="flex items-center justify-between">
                  <div>
                    <h1 className="font-semibold text-primaryBlack mb-1 text-xl mt-3">
                      {teamMember.name}
                    </h1>
                    <span>{teamMember.title}</span>
                  </div>
                  <div className="flex items-center space-x-5">
                    <img src={linkedin} alt="" className="w-7 h-7" />
                    <img src={twitter} alt="" className="w-7 h-7" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Team;
